import { OptionsType } from "./interface";

/** 搜索过滤 */
export function filterOption(data: OptionsType[], searchValue?: string): OptionsType[] {
  if (!searchValue) return data;
  const newData: OptionsType[] = [];
  data.forEach(item => {
    const { children, label, } = item;
    if (Array.isArray(children) && children.length) {
      const newChildren = children.filter(v => {
        const childrenLabel = v.label;
        const subChildrenLabel = v.subLabel;
        const isInclude = typeof childrenLabel === 'string' && childrenLabel.includes(searchValue);
        const isSubInclude = typeof subChildrenLabel === 'string' && subChildrenLabel.includes(searchValue);
        return isInclude || isSubInclude;
      });
      if (newChildren.length) {
        newData.push({
          ...item,
          children: newChildren,
        });
      }
    } else {
      const isInclude = typeof label === 'string' && label.includes(searchValue);
      if (isInclude) newData.push(item);
    }
  });
  return newData;
}